<template>
  <div class="request-access-page">
    <div class="language-picker">
      <el-select v-model="selectedLanguage" size="small" @change="change_language">
        <el-option
          v-for="language in supportedLanguages"
          :key="language.code"
          :label="language.label"
          :value="language.code">
        </el-option>
      </el-select>
    </div>
    <div class="request-access-card">
      <div class="icon-stack" aria-hidden="true">
        <span class="domain-icon"><i></i><i></i><i></i><i></i></span>
        <span class="lock-icon"></span>
      </div>
      <h1>{{ submitted ? $t("request_access.sent_title") : $t("request_access.request_title") }}</h1>
      <p class="subtitle">{{ submitted ? $t("request_access.sent_subtitle") : $t("request_access.request_subtitle") }}</p>
      <p v-if="email" class="account">{{ email }}</p>

      <el-form v-if="!submitted" label-position="top" class="request-form" v-loading="loading">
        <el-form-item :label="$t('request_access.country')">
          <el-select v-model="country" filterable :placeholder="$t('request_access.country_placeholder')" class="full-width" @change="on_country_change">
            <el-option v-for="item in countries" :key="item" :label="country_label(item)" :value="item"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item :label="$t('request_access.factory')">
          <el-select v-model="factoryId" filterable clearable :placeholder="$t('request_access.factory_placeholder')" class="full-width">
            <el-option v-for="item in filtered_factories" :key="item.Id" :label="format_factory(item)" :value="item.Id"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item :label="$t('request_access.message')">
          <el-input
            type="textarea"
            :rows="4"
            v-model="message"
            maxlength="1000"
            show-word-limit
            :placeholder="$t('request_access.message_placeholder')">
          </el-input>
        </el-form-item>

        <div class="actions">
          <el-button @click="back_to_login">{{ $t("request_access.back") }}</el-button>
          <el-button type="primary" :disabled="!can_submit" @click="submit_request">{{ $t("request_access.submit") }}</el-button>
        </div>
      </el-form>

      <div v-else class="success-panel">
        <p>{{ $t("request_access.success_message") }}</p>
        <el-button type="primary" @click="back_to_login">{{ $t("request_access.back_to_login") }}</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import settings from "./../backend/LocalSettings";
import { countryLabel } from "./../utils/countries";
import { SUPPORTED_LANGUAGES, normalizeLanguage } from "./../utils/languages";

export default {
  name: "request-access",
  data() {
    return {
      supportedLanguages: SUPPORTED_LANGUAGES,
      selectedLanguage: normalizeLanguage(window.localStorage.getItem("locale") || "en"),
      email: "",
      contactEmail: "b.haukova@salesianer.com",
      country: "",
      factoryId: "",
      message: "",
      countries: [],
      factories: [],
      loading: false,
      submitted: false
    };
  },
  computed: {
    filtered_factories() {
      if (!this.country) return this.factories;
      return this.factories.filter((factory) => factory.Country === this.country);
    },
    can_submit() {
      return this.email !== "" && (this.country !== "" || this.factoryId !== "" || this.message.trim() !== "");
    }
  },
  methods: {
    change_language(language) {
      var locale = normalizeLanguage(language);
      this.selectedLanguage = locale;
      window.localStorage.setItem("locale", locale);
      Vue.http.headers.common["Language"] = locale;
      this.$i18n.locale = locale;
    },
    load_options() {
      this.loading = true;
      this.$http
        .post("auth/request_options", {})
        .then(function(response) {
          this.loading = false;
          if (response.body.ContactEmail) {
            this.contactEmail = response.body.ContactEmail;
          }
          this.countries = response.body.Countries || [];
          this.factories = response.body.Factories || [];
        }, function() {
          this.loading = false;
        });
    },
    format_factory(factory) {
      if (!factory) return "";
      return factory.Country ? factory.ShortCode + " - " + this.country_label(factory.Country) : factory.ShortCode;
    },
    country_label(country) {
      return countryLabel(this, country);
    },
    on_country_change() {
      if (!this.factoryId) return;
      var selected = this.factories.find((factory) => parseInt(factory.Id) === parseInt(this.factoryId));
      if (selected && selected.Country !== this.country) this.factoryId = "";
    },
    submit_request() {
      if (!this.can_submit) return;
      this.loading = true;
      this.$http
        .post("auth/request_access", {
          email: this.email,
          country: this.country,
          factory_id: this.factoryId,
          message: this.message
        })
        .then(function(response) {
          this.loading = false;
          if (response.body.Success) {
            this.submitted = true;
            return;
          }
          this.$message.error(response.body.Message || this.$t("request_access.send_failed"));
        }, function() {
          this.loading = false;
          this.$message.error(this.$t("request_access.send_failed"));
        });
    },
    back_to_login() {
      settings.set_token("");
      this.$rights.clear_rights();
      this.$router.push("/");
    }
  },
  mounted() {
    this.change_language(this.selectedLanguage);
    settings.set_token("");
    this.$rights.clear_rights();
    this.email = this.$route.query.email || "";
    this.load_options();
  }
};
</script>

<style lang="less" scoped>
  .request-access-page {
    position: relative;
    min-height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 32px;
  }

  .language-picker {
    position: absolute;
    top: 18px;
    right: 18px;
    width: 160px;
    z-index: 2;
  }

  .request-access-card {
    width: 620px;
    max-width: 100%;
    padding: 48px;
    text-align: center;
    background: #ffffff;
    border-radius: 8px;
    box-shadow: rgba(15, 23, 42, 0.18) 0px 24px 60px;
  }

  .icon-stack {
    position: relative;
    display: inline-flex;
    justify-content: center;
    align-items: center;
    width: 96px;
    height: 82px;
    margin-bottom: 18px;
  }

  .domain-icon {
    display: grid;
    grid-template-columns: repeat(2, 28px);
    grid-template-rows: repeat(2, 22px);
    gap: 8px;
    padding: 10px;
    border: 5px solid #0f6cbd;
    border-radius: 6px;
  }

  .domain-icon i {
    background: #0f6cbd;
    opacity: 0.85;
  }

  .lock-icon {
    position: absolute;
    right: 12px;
    bottom: 8px;
    width: 28px;
    height: 28px;
    border-radius: 50%;
    color: #fc544b;
    background: #fc544b;
    border: 4px solid #fff;
  }

  h1 {
    margin: 0 0 12px;
    font-size: 40px;
    font-weight: 700;
  }

  .subtitle {
    margin: 0 0 10px;
    font-size: 22px;
    color: #334155;
  }

  .account {
    margin: 0 0 16px;
    color: #64748b;
  }

  .request-form {
    margin-top: 24px;
    text-align: left;
  }

  .full-width {
    width: 100%;
  }

  .actions {
    display: flex;
    justify-content: flex-end;
    gap: 10px;
    margin-top: 8px;
  }

  .success-panel {
    margin-top: 24px;
    color: #475569;
    font-size: 17px;
  }

  @media only screen and (max-width: 768px) {
    .request-access-page {
      align-items: flex-start;
      padding: 18px;
      padding-top: 76px;
    }

    .language-picker {
      left: 18px;
      right: 18px;
      width: auto;
    }

    .request-access-card {
      padding: 34px 24px;
    }

    h1 {
      font-size: 34px;
    }

    .actions {
      flex-direction: column-reverse;
    }

    .actions .el-button {
      width: 100%;
      margin-left: 0;
    }
  }
</style>
